<template>
  <MgdTooltipProvider>
    <NuxtLoadingIndicator color="var(--color-primary)" />
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <PrintVoidWatermark />
  </MgdTooltipProvider>
</template>
<script lang="ts" setup>
useHead({
  titleTemplate: (title) =>
    title ? "%s - Midland Garage Door" : "Dealer Portal - Midland Garage Door",
});
</script>
